<template>
<div class="px-4 py-2">
    <div>
        <div class="d-flex justify-content-between mt-3">
            <div class="">
                <button type="button" class="btn btn-secondary" @click="mtdChangeView('gestionPacientes')">
                    <i class="fas fa-arrow-left"></i> Volver
                </button>
            </div>
            <div class="btn-home">
                <button type="button" class="btn btn-outline-main" @click="mtdChangeView('home')">
                    <i class="fas fa-home-lg-alt"></i> Inicio
                </button>
            </div>
        </div>
        <div id="div-modal-cxc" class="d-flex justify-content-center mt-3">
            <div id="div-cxc" class="card w-100">
                <div class="text-center card-header text-white h5 bg-main">
                    <strong>PACIENTES EMERGENCIAS - HOSPITALIZADOS</strong>
                </div>
                <div class="card-body w-100">
                    <div class="col-md-12">
                        <div class="row d-flex">
                            <div class="mt-2" :class="cpData.length == 0 ? 'col-md-6' : 'col-xl-5 col-lg-5 col-md-5 col-sm-12'">
                                <div class="input-group input-group-sm">
                                    <span class="input-group-text col-md-4">Desde</span>
                                    <input type="date" aria-label="shift_date" class="form-control form-control-sm" id="begindate" v-model="filter.init" @change="mtdGetData" />
                                </div>
                            </div>
                            <div class="mt-2" :class="cpData.length == 0 ? 'col-md-6' : 'col-xl-5 col-lg-5 col-md-4 col-sm-12'">
                                <div class="input-group input-group-sm">
                                    <span class="input-group-text col-md-5">Hasta</span>
                                    <input type="date" aria-label="shift_date" class="form-control form-control-sm" id="end" v-model="filter.end" @change="mtdGetData" />
                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-3 col-sm-12 mt-2" v-if="cpData.length > 0">
                                <button type="button" class="btn text-white bg-main text-xs w-100" @click="viewPdf()">
                                    <i class="fa fa-file-pdf"></i>&nbsp; Exportar PDF
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <!-- Pag -->
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center">
                            <div v-if="cpData.length > 0" class="d-flex justify-content-end mb-2">
                                <nav aria-label="Page navigation example">
                                    <ul class="pagination mb-1">
                                        <li class="page-item">
                                            <a class="page-link page" href="javascript:void(0)" @click="backPage">Anterior</a>
                                        </li>
                                        <li v-if="limitedStepPagination[0] !== 1" class="page-item">
                                            <a :class="selectPage === 1 ? 'page-link active' : 'page-link'" href="javascript:void(0)" @click="selectedPage(1)">1</a>
                                        </li>
                                        <li v-if="limitedStepPagination[0] > 2" class="page-item disabled">
                                            <span class="page-link">...</span>
                                        </li>

                                        <li v-for="(item, index) in limitedStepPagination" :key="index" class="page-item">
                                            <a :class="selectPage === item ? 'page-link active' : 'page-link'" href="javascript:void(0)" @click="selectedPage(item)">{{ item }}
                                            </a>
                                        </li>
                                        <li v-if=" limitedStepPagination[limitedStepPagination.length - 1] <stepPagination.length - 1" class="page-item disabled">
                                            <span class="page-link">...</span>
                                        </li>
                                        <li v-if=" limitedStepPagination[limitedStepPagination.length - 1] !== stepPagination.length" class="page-item">
                                            <a :class="selectPage === limitedStepPagination.length + 2 ? 'page-link active':'page-link'" href="javascript:void(0)" @click="selectedPage(stepPagination.length)">{{ stepPagination.length }}
                                            </a>
                                        </li>
                                        <li class="page-item">
                                            <a class="page-link page" href="javascript:void(0)" @click="nextPage">Siguiente</a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <div class="col-md-12 table-responsive mb-2" id="div-tabla-anular">
                            <table id="tb-anular" class="table table-bordered">
                                <thead class="bg-main">
                                    <tr class="text-white align-middle text-xxs">
                                        <th scope="col">N°</th>
                                        <th scope="col">FECHA DE INGRESO</th>
                                        <th scope="col">FECHA DE ALTA</th>
                                        <th scope="col" class="table-th-number">DIAS</th>
                                        <th scope="col"><span class="me-2 ms-2">ALTA</span></th>
                                        <th scope="col">HORA DE INGRESO</th>
                                        <th scope="col" class="nowrap">PACIENTE</th>
                                        <th scope="col">EDAD</th>
                                        <th scope="col">CONVENIO</th>
                                        <th scope="col" class="nowrap" style="width: 135px">MÉDICO</th>
                                        <th scope="col">ESPECIALIDAD</th>
                                        <th scope="col">DIAGNOSTICO</th>
                                        <th scope="col">CAMA</th>
                                        <th scope="col">ESTADO</th>
                                        <th scope="col">OBSERVACIÓN</th>
                                        <th scope="col">ACCIÓN</th>
                                    </tr>
                                </thead>

                                <tbody class="border-main text-xs">
                                    <tr v-if="cpData.length == 0">
                                        <td class="text-center align-middle" colspan="16">Sin Registros</td>
                                    </tr>
                                    <tr class="tbody-table align-middle text-xxs" v-for="(item, index) in cpData" :key="index">
                                        <td>{{ mtdNumber(index) }}</td>
                                        <td>{{ item.date_entry | formatDate }}</td>

                                        <td @click="mtdOutFocusInput(index, item.par)">
                                            <div class="d-flex justify-content-center" v-if="item.par == 0">
                                                <input type="date" class="form-control form-control-sm input-cantidad align-middle" 
                                                    :min="minDate" 
                                                    placeholder="F. Alta" 
                                                    :class="{'input-with-opacity': isButtonDisabled && posEditnumber !== index,}" 
                                                    @input="mtdCalculateDay(item)"
                                                    v-model="item.date_discharge" 
                                                />
                                            </div>
                                            <div v-else>
                                                {{item.date_discharge | formatDate}}
                                            </div>
                                        </td>

                                        <td>
                                            <div class="d-flex justify-content-center" v-if="item.par == 0">
                                                <input type="number" class="form-control form-control-sm input-cantidad align-middle" placeholder="Dias" 
                                                    readonly
                                                    v-model="item.days" 
                                                />
                                            </div>
                                            <div v-else>
                                                {{item.days}}
                                            </div>
                                        </td>

                                        <td>
                                            <div class="d-flex justify-content-center" v-if="item.par == 0">
                                                <select class="form-control form-control-sm input-cantidad align-middle" disabled
                                                        :class="{'input-with-opacity': isButtonDisabled && posEditnumber !== index,}"
                                                        v-model="item.discharge" 
                                                >
                                                    <option disabled value="">Alta</option>
                                                    <option value="1">SI</option>
                                                    <option value="0">NO</option>
                                                </select>
                                            </div>
                                            <div v-else>
                                                {{item.discharge == 1 ? 'SI' : 'NO'}}
                                            </div>
                                        </td>


                                        <td>{{ item.hour }}</td>
                                        <td>{{ item.patient_name }}</td>
                                        <td>{{ item.patient_year }}</td>
                                        <td>{{ item.convenio }}</td>

                                        <td @click="mtdOutFocusInput(index, item.par)">
                                            <div class="align-items-center align-middle" v-if="item.par == 0">
                                                <v-select
                                                    id="serviceSelect"
                                                    class="text-dark flex-grow-1"
                                                    label="name"
                                                    :options="doctor"
                                                    placeholder="Buscar"
                                                    :reduce="(name) => name.id"
                                                    @search="mtdGetDoctor"
                                                    :class="{'input-with-opacity': isButtonDisabled && posEditnumber !== index,}"
                                                    v-model="item.doctor_id"
                                                    @input="updateSpecialty(item)"
                                                />
                                            </div>
                                            <div v-else>
                                                {{item.doctor_name}}
                                            </div>
                                        </td>

                                        <td>
                                            <div class="d-flex justify-content-center" v-if="item.par == 0">
                                                <input type="text" class="form-control form-control-sm input-cantidad align-middle" placeholder="Especialidad" readonly
                                                    :class="{'input-with-opacity': isButtonDisabled && posEditnumber !== index,}"
                                                    v-model="item.specialty" 
                                                />
                                            </div>
                                            <div v-else>
                                                {{item.specialty ? item.specialty : '-'}}
                                            </div>
                                        </td>

                                        <td @click="mtdOutFocusInput(index, item.par)">
                                            <div class="d-flex justify-content-center" v-if="item.par == 0">
                                                <input type="text" class="form-control form-control-sm input-cantidad align-middle" placeholder="Diagnostico" 
                                                    :class="{'input-with-opacity': isButtonDisabled && posEditnumber !== index,}"
                                                    v-model="item.diagnosis"
                                                />
                                            </div>
                                            <div v-else>
                                                {{item.diagnosis}}
                                            </div>
                                        </td>

                                        <td>
                                            {{item.state_bed == 1 ? 'INDIVIDUAL' : 'COMPARTIDA'}}
                                        </td>


                                        <td @click="mtdOutFocusInput(index, item.par)">
                                            <div class="d-flex justify-content-center" v-if="item.par == 0">
                                                <select class="form-control form-control-sm input-cantidad align-middle"
                                                    :class="{'input-with-opacity': isButtonDisabled && posEditnumber !== index,}"
                                                    v-model="item.state_patient" 
                                                >
                                                    <option value="" disabled selected>Seleccione</option>
                                                    <option value="alta">ALTA</option>
                                                    <option value="altaVol">ALTA VOLUNTARIA</option>
                                                    <option value="fallecido">FALLECIDO</option>
                                                    <option value="hospitalizado">HOSPITALIZADO</option>
                                                    <option value="referido">REFERIDO</option>
                                                    <option value="retiro">RETIRO VOLUNTARIO</option>
                                                </select>
                                            </div>
                                            <div v-else>
                                                {{formatStatePatient(item.state_patient)}}
                                            </div>
                                        </td>

                                        <td @click="mtdOutFocusInput(index, item.par)">
                                            <div class="d-flex justify-content-center" v-if="item.par == 0">
                                                <textarea class="form-control form-control-sm input-cantidad align-middle" placeholder="Observación" 
                                                    :class="{'input-with-opacity': isButtonDisabled && posEditnumber !== index,}"
                                                    v-model="item.observation" rows="2"
                                                >   </textarea>
                                            </div>
                                            <div v-else>
                                                {{item.observation ? item.observation : '-'}}
                                            </div>
                                        </td>
                                        
                                        <td>
                                            <div class="text-center d-flex justify-content-center" v-if="item.par == 0">
                                                <button
                                                    class="btn btn-sm a-danger text-white color-main"
                                                    :disabled="isFormInvalid(item)"
                                                    @click="registerData(item)" >
                                                    <i class="fas fa-plus" style="font-size: 22px;"></i>
                                                </button>
                                            </div>
                                            <div id="state_speciality" v-else>
                                                <button
                                                    class="btn btn-sm a-primary text-white color-main" @click="openModalEdit(item)">
                                                    <i class="fas fa-edit" style="font-size: 22px;"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <cModalEditVue :title="modal.title" :boo_modal="modal.modal_form" :payload="modal.payload" :num="modal.num"
    @closeModal="closeModal" @Datadetail="Datadetail"/>
    <SweetAlert :swal="swal" ref="SweetAlert" />
</div>
</template>

<script>
import {mapActions} from "vuex";
import moment from "moment";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import cModalEditVue from '@/components/Admision/modal/ReportPatient/cModalEdit.vue'
export default {
    name: "c-reportPatient",
    components: {
        SweetAlert,
        cModalEditVue
    },
    data() {
        return {
            swal: null,
            search:"",
            dataShow: [],
            dataRe: [],
            doctor: [],
            filter: {
                init: null,
                end: null,
            },
            modal: {
                title: '',
                modal_form: false,
                payload: {},
                num: null
            },
            //Pag
            page: 0,
            selectPage: 1,
            stepPagination: [],
            totalPagesToShow: 4,
            action: "",
            minDate: moment().format('YYYY-MM-DD'),
            isButtonDisabled: false,
            posEditnumber: null,
        };
    },
    watch: {
        selectPage() {
            this.calculateData(10);
        },
    },
    computed: {
        cpData() {
            return this.dataShow;
        },
        limitedStepPagination() {
            const totalPages = this.stepPagination.length;
            const currentPage = this.selectPage;

            let startPage = 1;
            let endPage = totalPages;
            if (totalPages > this.totalPagesToShow) {
                const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

                if (currentPage > halfPagesToShow) {
                    startPage = currentPage - halfPagesToShow;
                    endPage = currentPage + halfPagesToShow - 1;

                    if (endPage > totalPages) {
                        endPage = totalPages;
                        startPage = totalPages - this.totalPagesToShow + 1;
                    }
                } else {
                    endPage = this.totalPagesToShow;
                }
            }

            return Array.from({
                    length: endPage - startPage + 1,
                },
                (_, i) => startPage + i
            );
        },

        isFormInvalid() {
            return (item) => {
                const fieldsToCheck = ['date_discharge', 'days', 'discharge', 'doctor_id', 'diagnosis'];

                for (const key of fieldsToCheck) {
                    if (item[key] === null || item[key] === "") {
                        return true;
                    }
                }
                return false;
            };
        }

    },
    created() {
        moment.locale("es");
        this.mtdAsignDate();
        this.mtdGetData();
    },
    methods: {
        ...mapActions(["get", "post"]),

        mtdAsignDate() {
            this.filter.init = moment().startOf('month').format("YYYY-MM-DD");
            this.filter.end = moment().endOf('month').format("YYYY-MM-DD");
        },

        //Traer Data
        mtdGetData: function () {
            this.post({
                url: this.$store.getters.get__url + "/reportPatient/index",
                token: this.$store.getters.get__token,
                params: this.filter
            })
            .then((response) => {
                this.dataRe = response.data;
                this.calculateData(10);
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        },

        mtdGetDoctor: function (search, loading) {
            if (search.length > 3) {
                this.doctor = [];
                loading(true);
                this.get({
                    url: this.$store.getters.get__url + "/reportPatient/mtdGetDoctor/" + search,
                    token: this.$store.getters.get__token,
                })
                .then((response) => {
                    this.doctor = response.data;
                    loading(false);
                })
                .catch((errors) => {
                    this.$refs.SweetAlert.showError(errors);
                });
            }
        },

        calculateData(items) {
            if (!this.dataRe || !this.dataRe.length) {
                return (this.dataShow = []);
            }
            let filteredData = this.dataRe;
            let indexInitial = this.selectPage;
            if (this.search.length >= 2 && this.search != "") {
                let query = this.search.toString().toUpperCase();
                filteredData = this.dataRe.filter((element) => {
                    let name = element.name.toString().toUpperCase();
                    return name.includes(query);
                });
                indexInitial = 1;
            }
            let totalPages = Math.ceil(filteredData.length / items);
            this.stepPagination = Array.from({
                    length: totalPages,
                },
                (_, index) => index + 1
            );

            let startIndex = (indexInitial - 1) * items;
            let endIndex = startIndex + (items - 1);
            this.dataShow = filteredData.slice(startIndex, endIndex + 1);
            this.count = this.count + 1;
        },

        mtdOutFocusInput(index, par) {
            if (this.posEditnumber !== index && this.posEditnumber !== null && par !== 1) {
                Swal.fire({
                    title: "Desea cambiar de fila?",
                    text: "Se borrarán los datos registrados!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Si, cambiar!",
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.doctor = [];
                        this.posEditnumber = index;
                    }
                });
            } else {
                this.posEditnumber = index;
            }

            this.isButtonDisabled = true;
        },

        formatObs(model) {
            switch (model) {
                case 'Hospitalization':
                    return 'HOSPITALIZACION';
                case 'Emergency':
                    return 'EMERGENCIA';
                case 'UciAdult':
                    return 'UCI ADULTO';
                default:
                    return "-";
            }
        },

        formatStatePatient(model){
            switch (model) {
                case 'alta':
                    return 'ALTA';
                case 'altaVol':
                    return 'ALTA VOLUNTARIA';
                case 'fallecido':
                    return 'FALLECIDO';
                case 'hospitalizado':
                    return 'HOSPITALIZADO';
                case 'referido':
                    return 'REFERIDO';
                case 'retiro':
                    return 'RETIRO VOLUNTARIO';
                default:
                    return "-";
            }
        },

        mtdCalculateDay(item) {
            if (item.date_entry && item.date_discharge) {
                const checkinDate = moment(item.date_entry);
                const altaDate = moment(item.date_discharge);
                const dayDifference = altaDate.diff(checkinDate, 'days');

                const reservation_id = item.reservation_id;
                const index = this.cpData.findIndex(data => data.reservation_id === reservation_id);
                if (index !== -1) {
                    this.$set(this.cpData[index], 'days', dayDifference);
                    this.$set(this.cpData[index], 'discharge', 1);
                }
            }
        },


        registerData(item) {
            this.$refs.SweetAlert.showConfirmSimple2("", "¿Estás seguro de Registrar estos Datos?", "warning", "Confirmar")
            .then((result) => {
                if (result.value) {
                    this.registrarDatos(item);
                }
            });
        },

        registrarDatos(item) {
            this.post({
                url: this.$store.getters.get__url + "/reportPatient/registerData",
                token: this.$store.getters.get__token,
                params: item
            })
            .then((response) => {
                if(response.statusCode == 200){
                    this.$refs.SweetAlert.showSuccess("Registrado Correctamente");
                    this.mtdGetData();
                }
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        },

        //Pdf
        viewPdf() {
            window.open(
                this.$store.getters.get__url + "/reportPatient/viewPdf/" 
                + this.filter.init + "/" + this.filter.end,
                "_blank"
            );
        },

        updateSpecialty(item) {
            item.specialty = null;
            const selectedDoctor = this.doctor.find(doctor => doctor.id === item.doctor_id);
            if (selectedDoctor && selectedDoctor.specialtie) {
                item.specialty = selectedDoctor.specialtie.name;
            } else {
                item.specialty = null;
            }
        },

        //Modal
        openModalEdit(item) {
            this.modal = {
                title: 'PACIENTES EMERGENCIAS - HOSPITALIZADOS',
                modal_form: true,
                payload: item,
                num: 1
            }
        },

        closeModal: function () {
            this.modal = {
                title: '',
                modal_form: false,
                payload: {},
                num: null
            }
        },

        Datadetail: function (payload_detail) {
            this.post({
                url: this.$store.getters.get__url + "/reportPatient/editState",
                token: this.$store.getters.get__token,
                params: payload_detail,
            })
            .then(response => {
                if(response.statusCode == 200){
                    this.$refs.SweetAlert.showSuccess("Registro Editado Correctamente");
                    this.closeModal()
                    this.mtdGetData();
                }else{
                    this.$refs.SweetAlert.showError("Error");
                }
            })
            .catch(error => {
                this.$refs.SweetAlert.showError(error);
            })
        },

        //Paginacion
        backPage() {
            this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
        },
        nextPage() {
            this.selectPage =
                this.selectPage < this.stepPagination.length ?
                this.selectPage + 1 :
                this.stepPagination.length;
        },
        selectedPage(page) {
            this.selectPage = page;
        },
        mtdNumber: function(index){
            return (this.selectPage-1)*10 + (index + 1)
        },
        mtdChangeView: function (option) {
            this.$emit("mtdChangePage", option);
        },
    },
    filters: {
        formatDate(date) {
        return date != null ? moment(date).format("DD/MM/YYYY") : "-";
        },
        formatDateTime(dateTime) {
        return dateTime != null ? moment(dateTime).format("DD/MM/YYYY HH:mm") : "-";
        },
    },
}
</script>
<style scoped>
    .input-with-opacity {
        opacity: 0.4;
    }
</style>

